module.exports = __webpack_public_path__ + "img/logo.1ca6af2a.png";